<page-headline
    [module]="'performance'"
    [moduleIcon]="'fa-heartbeat'"
    [pageTitle]="'Performance Home'"
>
</page-headline>

<app-transition-directory-cards [applicationPage]="'performance'"></app-transition-directory-cards>
